module.exports = __webpack_public_path__ + "media/demo_linebot/IMG_0822-19d28120.PNG";